<div class="ds-dashboard">

  <!-- Skeleton Loader -->
  @if (!dashboardDataLoaded) {
    <div class="ds-welcome-section">
      <div class="skeleton skeleton-title" style="width: 280px; height: 32px;"></div>
      <div class="skeleton skeleton-text" style="width: 360px; height: 18px; margin-top: 8px;"></div>
      <div class="skeleton skeleton-banner" style="width: 100%; height: 52px; margin-top: 16px; border-radius: 10px;"></div>
    </div>
    <div class="ds-stats-row">
      @for (i of [1,2,3,4]; track i) {
        <div class="skeleton skeleton-stat-card"></div>
      }
    </div>
    <div class="ds-tips-row">
      @for (i of [1,2,3]; track i) {
        <div class="skeleton skeleton-tip-card"></div>
      }
    </div>
    <div class="skeleton skeleton-section" style="height: 280px; border-radius: 16px; margin-bottom: 1.5rem;"></div>
    <div class="skeleton skeleton-section" style="height: 200px; border-radius: 16px; margin-bottom: 1.5rem;"></div>
  }

  <!-- Dashboard Content -->
  @if (dashboardDataLoaded) {
    <!-- Welcome Section -->
    <div class="ds-welcome-section">
      <h1 class="ds-welcome-title">{{ 'dsAdminDashboard.welcomeBack' | transloco: { firstName: firstName } }}</h1>
      <p class="ds-welcome-subtitle">{{ 'dsAdminDashboard.welcomeSubtitle' | transloco }}</p>
      <div class="ds-tip-banner">
        <i class="fa fa-lightbulb-o"></i>
        <span><strong>{{ 'dsAdminDashboard.proTip' | transloco }}</strong> {{ 'dsAdminDashboard.proTipUse' | transloco }} <strong>{{ 'dsAdminDashboard.switchAccount' | transloco }}</strong> {{ 'dsAdminDashboard.proTipFeature' | transloco }}</span>
      </div>
    </div>
    <!-- Platform Stats Overview -->
    <div class="ds-stats-header">
      <h2 class="ds-stats-title">{{ 'dsAdminDashboard.platformOverview' | transloco }}</h2>
      <p class="ds-stats-subtitle">{{ 'dsAdminDashboard.platformOverviewSubtitle' | transloco }}</p>
    </div>
    <div class="ds-stats-row">
      <div class="ds-stat-card">
        <div class="ds-stat-icon ds-icon-teal">
          <i class="fa fa-users"></i>
        </div>
        <div class="ds-stat-content">
          <div class="ds-stat-value">{{ adminDashboardData.ArtistAccounts?.TotalArtist || 0 }}</div>
          <div class="ds-stat-label">{{ 'dsAdminDashboard.totalArtists' | transloco }}</div>
          <div class="ds-stat-change">{{ 'dsAdminDashboard.proFreeBreakdown' | transloco: { pro: (adminDashboardData.ArtistAccounts?.TotalProArtist || 0), free: (adminDashboardData.ArtistAccounts?.TotalFreeArtist || 0) } }}</div>
        </div>
      </div>
      <div class="ds-stat-card">
        <div class="ds-stat-icon ds-icon-orange">
          <i class="fa fa-building"></i>
        </div>
        <div class="ds-stat-content">
          <div class="ds-stat-value">{{ adminDashboardData.GalleryAccounts?.TotalGallery || 0 }}</div>
          <div class="ds-stat-label">{{ 'dsAdminDashboard.totalGalleries' | transloco }}</div>
          <div class="ds-stat-change">{{ 'dsAdminDashboard.proFreeBreakdown' | transloco: { pro: (adminDashboardData.GalleryAccounts?.TotalProGallery || 0), free: (adminDashboardData.GalleryAccounts?.TotalFreeGallery || 0) } }}</div>
        </div>
      </div>
      <div class="ds-stat-card">
        <div class="ds-stat-icon ds-icon-teal">
          <i class="fa fa-picture-o"></i>
        </div>
        <div class="ds-stat-content">
          <div class="ds-stat-value">{{ adminDashboardData.TotalArtistProducts || 0 }}</div>
          <div class="ds-stat-label">{{ 'dsAdminDashboard.totalArtworks' | transloco }}</div>
          <div class="ds-stat-change">{{ 'dsAdminDashboard.acrossAllArtists' | transloco }}</div>
        </div>
      </div>
      <div class="ds-stat-card">
        <div class="ds-stat-icon ds-icon-orange">
          <i class="fa fa-user-plus"></i>
        </div>
        <div class="ds-stat-content">
          <div class="ds-stat-value">{{ totalUsers }}</div>
          <div class="ds-stat-label">{{ 'dsAdminDashboard.totalUsers' | transloco }}</div>
          <div class="ds-stat-change">{{ 'dsAdminDashboard.artistsGalleriesCombined' | transloco }}</div>
        </div>
      </div>
    </div>
    <!-- Tips Section -->
    <div class="ds-tips-row">
      <div class="ds-tip-card">
        <div class="ds-tip-icon ds-tip-icon-teal">
          <i class="fa fa-line-chart"></i>
        </div>
        <div class="ds-tip-content">
          <span class="ds-tip-title">{{ 'dsAdminDashboard.monitorUserGrowth' | transloco }}</span>
          <span class="ds-tip-text">{{ 'dsAdminDashboard.monitorUserGrowthText' | transloco }}</span>
        </div>
      </div>
      <div class="ds-tip-card">
        <div class="ds-tip-icon ds-tip-icon-orange">
          <i class="fa fa-envelope"></i>
        </div>
        <div class="ds-tip-content">
          <span class="ds-tip-title">{{ 'dsAdminDashboard.reviewCommunications' | transloco }}</span>
          <span class="ds-tip-text">{{ 'dsAdminDashboard.reviewCommunicationsText' | transloco }}</span>
        </div>
      </div>
      <div class="ds-tip-card">
        <div class="ds-tip-icon ds-tip-icon-teal">
          <i class="fa fa-server"></i>
        </div>
        <div class="ds-tip-content">
          <span class="ds-tip-title">{{ 'dsAdminDashboard.checkSystemHealth' | transloco }}</span>
          <span class="ds-tip-text">{{ 'dsAdminDashboard.checkSystemHealthText' | transloco }}</span>
        </div>
      </div>
    </div>
    <!-- Quick Actions Section -->
    <div class="ds-section">
      <div class="ds-section-header">
        <i class="fa fa-bolt ds-section-icon"></i>
        <div>
          <h2 class="ds-section-title">{{ 'dsAdminDashboard.quickActions' | transloco }}</h2>
          <p class="ds-section-subtitle">{{ 'dsAdminDashboard.quickActionsSubtitle' | transloco }}</p>
        </div>
      </div>
      <div class="ds-quick-actions">
        <div class="ds-action-card" (click)="navigateToArtists()">
          <div class="ds-action-header">
            <div class="ds-action-icon ds-action-teal">
              <i class="fa fa-users"></i>
            </div>
            <span class="ds-action-title">{{ 'dsAdminDashboard.manageArtists' | transloco }}</span>
          </div>
          <div class="ds-action-footer">
            <span class="ds-action-desc">{{ 'dsAdminDashboard.artistsRegistered' | transloco: { count: (adminDashboardData.ArtistAccounts?.TotalArtist || 0) } }}</span>
            <i class="fa fa-arrow-right ds-action-arrow"></i>
          </div>
        </div>
        <div class="ds-action-card" (click)="navigateToGalleries()">
          <div class="ds-action-header">
            <div class="ds-action-icon ds-action-orange">
              <i class="fa fa-building"></i>
            </div>
            <span class="ds-action-title">{{ 'dsAdminDashboard.manageGalleries' | transloco }}</span>
          </div>
          <div class="ds-action-footer">
            <span class="ds-action-desc">{{ 'dsAdminDashboard.galleriesRegistered' | transloco: { count: (adminDashboardData.GalleryAccounts?.TotalGallery || 0) } }}</span>
            <i class="fa fa-arrow-right ds-action-arrow"></i>
          </div>
        </div>
        <div class="ds-action-card" (click)="navigateToEmailTemplates()">
          <div class="ds-action-header">
            <div class="ds-action-icon ds-action-teal">
              <i class="fa fa-file-text"></i>
            </div>
            <span class="ds-action-title">{{ 'dsAdminDashboard.emailTemplates' | transloco }}</span>
          </div>
          <div class="ds-action-footer">
            <span class="ds-action-desc">{{ 'dsAdminDashboard.emailTemplatesDesc' | transloco }}</span>
            <i class="fa fa-arrow-right ds-action-arrow"></i>
          </div>
        </div>
        <div class="ds-action-card" (click)="navigateToSubscriptionRules()">
          <div class="ds-action-header">
            <div class="ds-action-icon ds-action-orange">
              <i class="fa fa-sliders"></i>
            </div>
            <span class="ds-action-title">{{ 'dsAdminDashboard.subscriptionRules' | transloco }}</span>
          </div>
          <div class="ds-action-footer">
            <span class="ds-action-desc">{{ 'dsAdminDashboard.subscriptionRulesDesc' | transloco }}</span>
            <i class="fa fa-arrow-right ds-action-arrow"></i>
          </div>
        </div>
        <div class="ds-action-card" (click)="navigateToSystemSettings()">
          <div class="ds-action-header">
            <div class="ds-action-icon ds-action-teal">
              <i class="fa fa-cog"></i>
            </div>
            <span class="ds-action-title">{{ 'dsAdminDashboard.systemSettings' | transloco }}</span>
          </div>
          <div class="ds-action-footer">
            <span class="ds-action-desc">{{ 'dsAdminDashboard.systemSettingsDesc' | transloco }}</span>
            <i class="fa fa-arrow-right ds-action-arrow"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- Platform Accounts Overview -->
    <div class="ds-section">
      <div class="ds-section-header">
        <i class="fa fa-pie-chart ds-section-icon"></i>
        <div>
          <h2 class="ds-section-title">{{ 'dsAdminDashboard.accountBreakdown' | transloco }}</h2>
          <p class="ds-section-subtitle">{{ 'dsAdminDashboard.accountBreakdownSubtitle' | transloco }}</p>
        </div>
      </div>
      <div class="ds-accounts-content">
        <div class="ds-accounts-grid">
          <!-- Artist Accounts Card -->
          <div class="ds-account-card">
            <div class="ds-account-header">
              <div class="ds-account-icon ds-account-icon-teal">
                <i class="fa fa-palette"></i>
              </div>
              <div>
                <div class="ds-account-title">{{ 'dsAdminDashboard.artistAccounts' | transloco }}</div>
                <div class="ds-account-total">{{ 'dsAdminDashboard.totalCount' | transloco: { count: (adminDashboardData.ArtistAccounts?.TotalArtist || 0) } }}</div>
              </div>
            </div>
            <div class="ds-account-bars">
              <div class="ds-account-bar-item">
                <div class="ds-account-bar-label">
                  <span>{{ 'dsAdminDashboard.proArtists' | transloco }}</span>
                  <span class="ds-account-bar-value ds-text-success">{{ adminDashboardData.ArtistAccounts?.TotalProArtist || 0 }}</span>
                </div>
                <div class="ds-account-bar-track">
                  <div class="ds-account-bar-fill ds-bar-success" [style.width.%]="artistProPercentage"></div>
                </div>
              </div>
              <div class="ds-account-bar-item">
                <div class="ds-account-bar-label">
                  <span>{{ 'dsAdminDashboard.freeArtists' | transloco }}</span>
                  <span class="ds-account-bar-value ds-text-muted">{{ adminDashboardData.ArtistAccounts?.TotalFreeArtist || 0 }}</span>
                </div>
                <div class="ds-account-bar-track">
                  <div class="ds-account-bar-fill ds-bar-muted" [style.width.%]="100 - artistProPercentage"></div>
                </div>
              </div>
            </div>
            <div class="ds-account-footer">
              <span class="ds-account-conversion">{{ 'dsAdminDashboard.conversionToPro' | transloco: { percentage: artistProPercentage } }}</span>
            </div>
          </div>
          <!-- Gallery Accounts Card -->
          <div class="ds-account-card">
            <div class="ds-account-header">
              <div class="ds-account-icon ds-account-icon-orange">
                <i class="fa fa-building"></i>
              </div>
              <div>
                <div class="ds-account-title">{{ 'dsAdminDashboard.galleryAccounts' | transloco }}</div>
                <div class="ds-account-total">{{ 'dsAdminDashboard.totalCount' | transloco: { count: (adminDashboardData.GalleryAccounts?.TotalGallery || 0) } }}</div>
              </div>
            </div>
            <div class="ds-account-bars">
              <div class="ds-account-bar-item">
                <div class="ds-account-bar-label">
                  <span>{{ 'dsAdminDashboard.proGalleries' | transloco }}</span>
                  <span class="ds-account-bar-value ds-text-success">{{ adminDashboardData.GalleryAccounts?.TotalProGallery || 0 }}</span>
                </div>
                <div class="ds-account-bar-track">
                  <div class="ds-account-bar-fill ds-bar-success" [style.width.%]="galleryProPercentage"></div>
                </div>
              </div>
              <div class="ds-account-bar-item">
                <div class="ds-account-bar-label">
                  <span>{{ 'dsAdminDashboard.freeGalleries' | transloco }}</span>
                  <span class="ds-account-bar-value ds-text-muted">{{ adminDashboardData.GalleryAccounts?.TotalFreeGallery || 0 }}</span>
                </div>
                <div class="ds-account-bar-track">
                  <div class="ds-account-bar-fill ds-bar-muted" [style.width.%]="100 - galleryProPercentage"></div>
                </div>
              </div>
            </div>
            <div class="ds-account-footer">
              <span class="ds-account-conversion">{{ 'dsAdminDashboard.conversionToPro' | transloco: { percentage: galleryProPercentage } }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Revenue Insights -->
    <div class="ds-section">
      <div class="ds-section-header">
        <i class="fa fa-bar-chart ds-section-icon"></i>
        <div>
          <h2 class="ds-section-title">{{ 'dsAdminDashboard.revenueInsights' | transloco }}</h2>
          <p class="ds-section-subtitle">{{ 'dsAdminDashboard.revenueInsightsSubtitle' | transloco }}</p>
        </div>
      </div>
      <div class="ds-chart-content">
        @if (adminDashboardData.StripeInsightsCharts) {
          <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="selectedTabIndex">
            @for (item of adminDashboardData.StripeInsightsCharts; track item) {
              <p-tabPanel [header]="item.SeriesName">
                <admin-insights-chart [insightsSeriesData]="item" [selectedTabIndex]="selectedTabIndex"></admin-insights-chart>
              </p-tabPanel>
            }
          </p-tabView>
        }
        @if (!adminDashboardData.StripeInsightsCharts) {
          <div class="ds-empty-state">
            <i class="fa fa-bar-chart"></i>
            <h4>{{ 'dsAdminDashboard.noRevenueData' | transloco }}</h4>
            <p>{{ 'dsAdminDashboard.noRevenueDataText' | transloco }}</p>
          </div>
        }
      </div>
    </div>
    <!-- Quick Links Section -->
    <div class="ds-section">
      <div class="ds-section-header">
        <i class="fa fa-link ds-section-icon"></i>
        <div>
          <h2 class="ds-section-title">{{ 'dsAdminDashboard.moreAdminTools' | transloco }}</h2>
          <p class="ds-section-subtitle">{{ 'dsAdminDashboard.moreAdminToolsSubtitle' | transloco }}</p>
        </div>
      </div>
      <div class="ds-quick-links-content">
        <div class="ds-quick-links-grid">
          <div class="ds-quick-link" (click)="navigateToApplicationLogs()">
            <div class="ds-quick-link-icon ds-ql-icon-teal">
              <i class="fa fa-server"></i>
            </div>
            <div class="ds-quick-link-info">
              <span class="ds-quick-link-title">{{ 'dsAdminDashboard.applicationLogs' | transloco }}</span>
              <span class="ds-quick-link-desc">{{ 'dsAdminDashboard.applicationLogsDesc' | transloco }}</span>
            </div>
            <i class="fa fa-arrow-right ds-quick-link-arrow"></i>
          </div>
          <div class="ds-quick-link" (click)="navigateToEmailLogs()">
            <div class="ds-quick-link-icon ds-ql-icon-orange">
              <i class="fa fa-list"></i>
            </div>
            <div class="ds-quick-link-info">
              <span class="ds-quick-link-title">{{ 'dsAdminDashboard.emailLogs' | transloco }}</span>
              <span class="ds-quick-link-desc">{{ 'dsAdminDashboard.emailLogsDesc' | transloco }}</span>
            </div>
            <i class="fa fa-arrow-right ds-quick-link-arrow"></i>
          </div>
          <div class="ds-quick-link" (click)="navigateToArtTypes()">
            <div class="ds-quick-link-icon ds-ql-icon-teal">
              <i class="fa fa-tags"></i>
            </div>
            <div class="ds-quick-link-info">
              <span class="ds-quick-link-title">{{ 'dsAdminDashboard.artTypes' | transloco }}</span>
              <span class="ds-quick-link-desc">{{ 'dsAdminDashboard.artTypesDesc' | transloco }}</span>
            </div>
            <i class="fa fa-arrow-right ds-quick-link-arrow"></i>
          </div>
          <div class="ds-quick-link" (click)="navigateToEventWorkflow()">
            <div class="ds-quick-link-icon ds-ql-icon-orange">
              <i class="fa fa-sitemap"></i>
            </div>
            <div class="ds-quick-link-info">
              <span class="ds-quick-link-title">{{ 'dsAdminDashboard.eventWorkflow' | transloco }}</span>
              <span class="ds-quick-link-desc">{{ 'dsAdminDashboard.eventWorkflowDesc' | transloco }}</span>
            </div>
            <i class="fa fa-arrow-right ds-quick-link-arrow"></i>
          </div>
          <div class="ds-quick-link" (click)="navigateToSmsTemplates()">
            <div class="ds-quick-link-icon ds-ql-icon-teal">
              <i class="fa fa-mobile"></i>
            </div>
            <div class="ds-quick-link-info">
              <span class="ds-quick-link-title">{{ 'dsAdminDashboard.smsTemplates' | transloco }}</span>
              <span class="ds-quick-link-desc">{{ 'dsAdminDashboard.smsTemplatesDesc' | transloco }}</span>
            </div>
            <i class="fa fa-arrow-right ds-quick-link-arrow"></i>
          </div>
          <div class="ds-quick-link" (click)="navigateToEmailEvents()">
            <div class="ds-quick-link-icon ds-ql-icon-orange">
              <i class="fa fa-bolt"></i>
            </div>
            <div class="ds-quick-link-info">
              <span class="ds-quick-link-title">{{ 'dsAdminDashboard.emailEvents' | transloco }}</span>
              <span class="ds-quick-link-desc">{{ 'dsAdminDashboard.emailEventsDesc' | transloco }}</span>
            </div>
            <i class="fa fa-arrow-right ds-quick-link-arrow"></i>
          </div>
        </div>
      </div>
    </div>
  }
</div>
